module.exports = __webpack_public_path__ + "img/bhutan.b4798b86.png";